import { useEffect, useRef } from 'react'
import { createUseStyles } from 'react-jss'
import classNames from 'classnames'
import { useSelector, shallowEqual } from 'react-redux'
import gsap from 'gsap'
import style from './style'

const useStyles = createUseStyles(style)

const Loader = () => {
  const classes = useStyles()
  const $firstLine = useRef()
  const $secondLine = useRef()
  const $root = useRef()

  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { siteLoaded } = useSelector((state) => ({
    siteLoaded: state.loading.siteLoaded,
  }), shallowEqual)

  const animateLoaderEnd = () => {
    gsap.killTweensOf([$firstLine.current, $secondLine.current])
    const timeline = gsap.timeline()
    timeline
      .to($firstLine.current, ({
        x: 0,
        ease: 'power3.inOut',
      }), 0)
      .to($secondLine.current, ({
        x: 0,
        ease: 'power3.inOut',
      }), 0)
      .to($firstLine.current, ({
        x: '-=23',
        y: '+=29',
        ease: 'power3.out',
      }), 0.9)
      .to($secondLine.current, ({
        x: '+=23',
        y: '-=29',
        ease: 'power3.out',
      }), 0.9)
      .to($root.current, ({
        autoAlpha: 0,
      }), 1.2)
  }

  const animateLoader = () => {
    gsap.to($firstLine.current, ({
      x: '+=13',
      duration: 1.2,
      repeat: -1,
      yoyo: true,
      ease: 'power3.inOut',
    }))
    gsap.to($secondLine.current, ({
      x: '-=13',
      duration: 1.2,
      repeat: -1,
      yoyo: true,
      ease: 'power3.inOut',
    }))
  }

  useEffect(() => {
    if (siteLoaded) animateLoaderEnd()
  }, [siteLoaded])

  /*------------------------------
  Did Mount
  ------------------------------*/
  useEffect(() => {
    animateLoader()
  }, [])

  /*------------------------------
  Render
  ------------------------------*/
  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.hide]: siteLoaded,
      })}
      ref={$root}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="44.992"
        height="29.033"
        viewBox="0 0 44.992 29.033"
        className={classes.logo}
      >
        <path
          ref={$firstLine}
          className={classes.firstLine}
          d="M0 29.033L22.8 0h9.19L9.462 29.033z"
        />
        <path
          ref={$secondLine}
          className={classes.secondLine}
          d="M13 29.033L35.8 0h9.19L22.462 29.033z"
        />
      </svg>
    </div>
  )
}

export default Loader
